module.exports = __webpack_public_path__ + "static/media/mobile-icon.4c9cde40.svg";